import { useEffect } from 'react'

import { useAnalyticsClient } from '@acorns/web-utils'

import {
  APP_LOAD_START,
  APP_LOAD_START_INIT,
  APP_LOAD_TIME_TO_INIT_TRACKED,
} from './constants'

function calculateAppLoadTimeSeconds() {
  const start = parseInt(
    window.sessionStorage.getItem(APP_LOAD_START) ?? '',
    10,
  )
  const end = parseInt(
    window.sessionStorage.getItem(APP_LOAD_START_INIT) ?? '',
    10,
  )

  if (Number.isInteger(start) && Number.isInteger(end)) {
    return (end - start) / 1000
  }

  return null
}

export function TrackAppLoadTime() {
  const analyticsClient = useAnalyticsClient()

  useEffect(() => {
    if (
      analyticsClient &&
      window.sessionStorage.getItem(APP_LOAD_TIME_TO_INIT_TRACKED) !== 'true' // avoid tracking load time for page refreshes
    ) {
      const appLoadTime = calculateAppLoadTimeSeconds()

      if (appLoadTime) {
        window.sessionStorage.setItem(APP_LOAD_TIME_TO_INIT_TRACKED, 'true')
        analyticsClient.track('Time Analysis', {
          object_name: 'webAppLoadTimeToInit',
          delta_seconds: appLoadTime,
        })
      }
    }
  }, [analyticsClient])

  return null
}
